<template>
        <div v-if="content.unitaryPrice != 0" class="card qb-card qb-padding" :class="grid" v-on:click="$emit('card-click')">
            <div class="card-left">
                <slot name="image"></slot>
            </div>
            <div class="card-right">
                <h4>{{ content.description }}</h4>
                <div class="prices">
                    <p v-if="content.unitaryPrice != content.discountPrice" class="desconto qb-txt-sm">{{ priceFormater(content.unitaryPrice) }}</p>
                    <p v-if="content.unitaryPrice != content.discountPrice" class="qb-txt-sm">{{ content.percentageDiscount }}%</p>
                    <p class="qb-txt-color-price qb-txt-bold qb-txt-md" style="flex-grow: 1" v-if="content.discountPrice">{{ priceFormater(content.discountPrice) }}</p>
                </div>
                <div>
                   <slot></slot>
                </div>
            </div>
        </div>
</template>

<script>

export default {
    components: {
    
    },

    props: {
        content: {
            required: true,
        },
        slider: {
            type: Boolean,
            default: false
        },
        onGrid:{
            type: Boolean,
            default: true
        },
        size: {
        type: String,
        default: '2'
        }
        },
    
    data(){
        return{
        }
    }, 
    computed: {
        tamanho(){
            if(this.slider){
                return 'slider';
            }
            return ''
            },
        grid(){
            if(this.onGrid){
                if(this.size == '7'){
                    return 'grid-7';
                }   
                return 'grid-2';
            }
            return '';
        }   
    },
     methods: {
        
        priceFormater(price){
            return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    }
}
</script>

<style scoped>
.qb-card {
    cursor: pointer;
}
.card{
  display: flex;
  align-items: center;
  background-color: #fff;
}

.card-left{
  width: 100%;
  max-height: 200px; 
} 

.card-right{
     width: 90%;
 }
 .card-right h4{
     height: 60px;
 }

.card-left img{
    max-height: 200px;
    max-width: 100%;
    min-height: 200px;
    object-fit: contain;
}

.desconto{
    text-decoration:  line-through;
    flex-grow: 1;
}

@media screen and (max-width: 900px) and (min-width: 600px) {
}

@media screen and (min-width: 600px){
  .card{
      flex-direction: column;
      text-align: center;
  }

  .card-right{
      max-width: 100%;
      width: 100%;
      margin-left: 0px;
  }

  .prices{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .percDiscount{
      font-size: 12px;
  }
}

@media screen and (min-width: 900 px){
    .card{
        min-width: 200px;
    }
}
</style>
